import React from "react";
import { Typography } from "antd";
import ModalComponent from "components/Common/Modal/Modal";

interface DeleteProductModal {
  isDeleteModalVisible: boolean;
  deleteProduct: () => void;
  setIsDeleteModalVisible: () => void;
}

const { Text } = Typography;

const DeleteProductModal: React.FC<DeleteProductModal> = ({
  isDeleteModalVisible,
  deleteProduct,
  setIsDeleteModalVisible,
}: DeleteProductModal) => (
  <ModalComponent
    title="Delete Product"
    visible={isDeleteModalVisible}
    onOK={deleteProduct}
    onCancel={setIsDeleteModalVisible}
    okText="Yes"
    cancelText="No"
    dataTestSelector="popDeleteProduct"
    zIndex={10}
    isMaskClosable={true}
    className="standard-modal"
  >
    <Text className="modal-content">Are you sure, you want to delete?</Text>
  </ModalComponent>
);
export default DeleteProductModal;
